import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import {
  debounce as _debounce,
  get as _get,
} from 'lodash';
import { deepDiveExpand as trackDeepDiveExpand } from 'analytics/deepDive';

import { Icon } from 'sheets';
import { ResponsiveImage } from 'sheets';
import StarryBackground from 'components/StarryBackground/StarryBackground';

import styles from './DeepDive.css';

const cx = classNames.bind(styles);

class DeepDive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      blocksHeight: 0,
    };
    this.expandDeepDive = this.toggleIsExpanded.bind(this, true);
    this.collapseDeepDive = this.toggleIsExpanded.bind(this, false);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.resizeBlocks = this.resizeBlocks.bind(this);
    this.onResize = _debounce(this.resizeBlocks, 200);
  }

  componentDidMount() {
    window.addEventListener(`resize`, this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener(`resize`, this.onResize);
  }

  resizeBlocks() {
    this.setState({
      blocksHeight: this.getBlocksHeight(this.state.isExpanded),
    });
  }

  handleKeyPress(e) {
    const keyCode = e.which || e.keyCode;

    if (keyCode === 13) {
      this.expandDeepDive();
    }
  }

  toggleIsExpanded(isExpanded) {
    this.setState({
      isExpanded,
      blocksHeight: this.getBlocksHeight(isExpanded),
    });
    if (isExpanded && !this.state.isExpanded) {
      trackDeepDiveExpand(this.props.analytics.category, this.props.englishPromptText);
    }
  }

  getBlocksHeight(isExpanded) {
    if (isExpanded) {
      return this.blocksWrapper.getBoundingClientRect().height;
    }

    return 0;
  }

  renderCircleButton(icon, onClick, buttonClass) {
    return (
      <button
        className={buttonClass}
        onClick={onClick}
      >
        <Icon
          className={styles[`toggle-button-icon`]}
          name={icon}
        />
      </button>
    );
  }

  renderBlocksHeading() {
    if (!this.props.t.blocksHeading) {
      return null;
    }

    return (
      <p className={styles[`blocks-heading`]}>
        {this.props.t.blocksHeading}
      </p>
    );
  }

  render() {
    const containerClass = cx(`container`, {
      'container--open': this.state.isExpanded,
      [this.props.containerStyles]: this.props.containerStyles,
    });
    const promptClass = cx(`prompt-content`, {
      'prompt-content--hidden': this.state.isExpanded,
    });
    const openButtonClass = cx(`toggle-button--open`, {
      'toggle-button--hidden': this.state.isExpanded,
    });
    const closeButtonClass = cx(`toggle-button--close`, {
      'toggle-button--hidden': !this.state.isExpanded,
    });
    const contentStyles = {
      height: this.state.blocksHeight,
    };
    const eyeIconConfig = {
      path: `products_new/shared/eye_blinking.gif`,
      sizes: `32px`,
      min: 32,
    };

    return (
      <div className={containerClass}>
        <StarryBackground isHidden={!this.state.isExpanded} />
        <div className={styles[`prompt`]}>
          <div
            className={promptClass}
            onClick={this.expandDeepDive}
            onKeyPress={this.handleKeyPress}
            role="button"
            tabIndex="0"
          >
            <ResponsiveImage
              className={styles[`icon-eye`]}
              config={eyeIconConfig}
              description={`Winking Eye`}
            />
            <p className={styles[`prompt-text`]}>{this.props.t.promptText}</p>
            {this.renderCircleButton(`plus-circle`, null, openButtonClass)}
          </div>
          {this.renderCircleButton(`x-circle`, this.collapseDeepDive, closeButtonClass)}
        </div>
        <div
          className={styles[`content`]}
          style={contentStyles}
        >
          <div
            className={styles[`content-inner`]}
            ref={(el) => { this.blocksWrapper = el; }}
          >
            {this.renderBlocksHeading()}
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

DeepDive.propTypes = {
  analytics: PropTypes.shape({
    category: PropTypes.string,
  }),
  containerStyles: PropTypes.string,
  englishPromptText: PropTypes.string.isRequired,
  t: PropTypes.shape({
    blocksHeading: PropTypes.string,
    promptText: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  analytics: {
    category: _get(state, `product.productCategory`),
  },
});

export default connect(mapStateToProps)(DeepDive);
